import { type ThirdPartyConfig } from '../schemas/3p-config';

import { adobeSignConfig } from './adobe-sign';
import { adobeXDConfig } from './adobe-xd';
import { ahaConfig } from './aha';
import { airtableConfig } from './airtable';
import { amplitudeConfig } from './amplitude';
import { asanaConfig } from './asana';
import { atlassianWebCrawlerConfig } from './atlassian-web-crawler';
import { awss3Config } from './aws-s3';
import { azureDevopsConfig } from './azure-devops';
import { boxConfig } from './box';
import { canvaConfig } from './canva';
import { clickUpConfig } from './clickup';
import { confluenceDCConfig } from './confluence-dc';
import { databricksConfig } from './databricks';
import { docusignConfig } from './docusign';
import { dovetailConfig } from './dovetail';
import { dropboxConfig } from './dropbox';
import { figmaConfig } from './figma';
import { forgeAdamVitareqConfig as forgeAdamVitareqDevConfig } from './forge-adam-vitareq-dev';
import { forgeAdamVitareqConfig as forgeAdamVitareqProdConfig } from './forge-adam-vitareq-prod';
import { forgeGdriveEugeneTestDevConfig } from './forge-gdrive-eugene-test-dev';
import { forgeGdriveEugeneTestProdConfig } from './forge-gdrive-eugene-test-prod';
import { forgeK15tScrollSitesConfig as forgeK15tScrollSitesDevConfig } from './forge-k15t-scroll-sites-dev';
import { forgeK15tScrollSitesConfig as forgeK15tScrollSitesProdConfig } from './forge-k15t-scroll-sites-prod';
import { forgePioAwsConfig as forgePioAwsDevConfig } from './forge-pio-aws-dev';
import { forgePioAwsConfig as forgePioAwsProdConfig } from './forge-pio-aws-prod';
import { forgePioClickupConfig as forgePioClickupDevConfig } from './forge-pio-clickup-dev';
import { forgePioClickupConfig as forgePioClickupProdConfig } from './forge-pio-clickup-prod';
import { forgePioGitbookConfig as forgePioGitbookDevConfig } from './forge-pio-gitbook-dev';
import { forgePioGitbookConfig as forgePioGitbookProdConfig } from './forge-pio-gitbook-prod';
import { forgePioGithubConfig as forgePioGithubDevConfig } from './forge-pio-github-dev';
import { forgePioGithubConfig as forgePioGithubProdConfig } from './forge-pio-github-prod';
import { forgePioGitlabConfig as forgePioGitlabDevConfig } from './forge-pio-gitlab-dev';
import { forgePioGitlabConfig as forgePioGitlabProdConfig } from './forge-pio-gitlab-prod';
import { forgePioGoogleDriveConfig as forgePioGoogleDriveDevConfig } from './forge-pio-google-drive-dev';
import { forgePioGoogleDriveConfig as forgePioGoogleDriveProdConfig } from './forge-pio-google-drive-prod';
import { forgePioGuruConfig as forgePioGuruDevConfig } from './forge-pio-guru-dev';
import { forgePioGuruConfig as forgePioGuruProdConfig } from './forge-pio-guru-prod';
import { forgePioHelpjuiceConfig as forgePioHelpjuiceDevConfig } from './forge-pio-helpjuice-dev';
import { forgePioHelpjuiceConfig as forgePioHelpjuiceProdConfig } from './forge-pio-helpjuice-prod';
import { forgePioHubspotConfig as forgePioHubspotDevConfig } from './forge-pio-hubspot-dev';
import { forgePioHubspotConfig as forgePioHubspotProdConfig } from './forge-pio-hubspot-prod';
import { forgePioSalesforceConfig as forgePioSalesforceDevConfig } from './forge-pio-salesforce-dev';
import { forgePioSalesforceConfig as forgePioSalesforceProdConfig } from './forge-pio-salesforce-prod';
import { forgePioSharepointConfig as forgePioSharepointDevConfig } from './forge-pio-sharepoint-dev';
import { forgePioSharepointConfig as forgePioSharepointProdConfig } from './forge-pio-sharepoint-prod';
import { forgePioStackOverflowConfig as forgePioStackOverflowDevConfig } from './forge-pio-stack-overflow-dev';
import { forgePioStackOverflowConfig as forgePioStackOverflowProdConfig } from './forge-pio-stack-overflow-prod';
import { forgeUtoolityGitbookConfig as forgeUtoolityGitbookDevConfig } from './forge-utoolity-gitbook-dev';
import { forgeUtoolityGitbookConfig as forgeUtoolityGitbookProdConfig } from './forge-utoolity-gitbook-prod';
import { freshserviceConfig } from './freshservice';
import { gitbookConfig } from './gitbook';
import { githubConfig } from './github';
import { gitlabConfig } from './gitlab';
import { gmailConfig } from './gmail';
import { googleDriveConfig } from './google';
import { googleCalendarConfig } from './google-calendar';
import { hubSpotConfig } from './hubspot';
import { jiraDCConfig } from './jira-dc';
import { jsmDCConfig } from './jsm-dc';
import { launchDarklyConfig } from './launchdarkly';
import { loomConfig } from './loom';
import { lucidConfig } from './lucid';
import { miroConfig } from './miro';
import { mondayConfig } from './monday';
import { muralConfig } from './mural';
import { notionConfig } from './notion';
import { oneDriveConfig } from './onedrive';
import { outlookCalendarConfig } from './outlook-calendar';
import { outlookMail } from './outlook-mail';
import { pagerDutyConfig } from './pagerduty';
import { pipedriveConfig } from './pipedrive';
import { powerBIConfig } from './powerBI';
import { salesforceConfig } from './salesforce';
import { sentryConfig } from './sentry';
import { serviceNowConfig } from './servicenow';
import { sharepointConfig } from './sharepoint';
import { slackConfig } from './slack';
import { smartsheetConfig } from './smartsheet';
import { stripeConfig } from './stripe';
import { teamsConfig } from './teams';
import { todoistConfig } from './todoist';
import { webexConfig } from './webex';
import { zendeskConfig } from './zendesk';
import { zeplinConfig } from './zeplin';
// New 3P? Add it here

export const ProductKeys3P = {
	AtlassianWebCrawler: 'atlassian-web-crawler',
	Figma: 'figma',
	Github: 'github',
	GoogleDrive: 'drive',
	Loom: 'loom',
	OneDrive: 'onedrive',
	Dropbox: 'dropbox',
	Slack: 'slack',
	Sharepoint: 'sharepoint',
	Teams: 'teams',
	GoogleCalendar: 'google-calendar',
	OutlookCalendar: 'outlook-calendar',
	OutlookMail: 'outlook-mail',
	Gmail: 'gmail',
	AdobeSign: 'adobe-sign',
	Asana: 'asana',
	Zendesk: 'zendesk',
	Airtable: 'airtable',
	Smartsheet: 'smartsheet',
	Notion: 'notion',
	Miro: 'miro',
	Docusign: 'docusign',
	Lucid: 'lucid',
	Monday: 'monday',
	AzureDevops: 'azure-devops',
	Gitlab: 'gitlab',
	ConfluenceDC: 'confluence-dc',
	Canva: 'canva',
	Box: 'box',
	Zeplin: 'zeplin',
	ServiceNow: 'servicenow',
	Freshservice: 'freshservice',
	PowerBI: 'power-bi',
	ClickUp: 'clickup',
	Amplitude: 'amplitude',
	Stripe: 'stripe',
	AdobeXD: 'adobexd',
	Aha: 'aha',
	Mural: 'mural',
	Webex: 'webex',
	Todoist: 'todoist',
	PagerDuty: 'pagerduty',
	Pipedrive: 'pipedrive',
	Hubspot: 'hubspot',
	Dovetail: 'dovetail',
	LaunchDarkly: 'launchdarkly',
	Salesforce: 'salesforce',
	Sentry: 'sentry',
	JiraDC: 'jira-dc',
	Gitbook: 'gitbook',
	AWSS3: 'aws-s3',
	Databricks: 'databricks',
	JsmDC: 'jsm-dc',
	ForgeAdamVitareqDev: 'forge-connector-dAkghOClvWGokDftTTaIgNoD6pnNt74z-vitareq-connector',
	ForgeAdamVitareqProd: 'forge-connector-EjfoGWrWrETl3Zc5zkGynPyESZO5Qu93-vitareq-connector',
	ForgeK15tScrollSitesDev:
		'forge-connector-h1n3NRFAn84v7ECSONVidlCS88qZh8cy-scroll-sites-connector',
	ForgeK15tScrollSitesProd:
		'forge-connector-ofe9zXccOCQ3U4t4kDVywSyJUoZjb1sO-scroll-sites-connector',
	ForgePioAwsDev: 'forge-connector-fb208da2-6b04-4471-8a74-40af53b7e6f1-s3-connector',
	ForgePioAwsProd: 'forge-connector-mRcqWRwqkUd4JwapGkvGHUViyySX9MVy-s3-connector',
	ForgePioClickupDev: 'forge-connector-ELuz3hTMhig0Jdrr6ytI45SifO9DfKrY-clickup-connector',
	ForgePioClickupProd: 'forge-connector-uwYqtNjM6w0QIhHOFG0Cq4cnkUM9mt3K-clickup-connector',
	ForgePioGitbookDev: 'forge-connector-Xh70v2yqkzOjTQqTMLxk1lElehWIXoYi-gitbook-connector',
	ForgePioGitbookProd: 'forge-connector-cQ1IDSmJT0DrQuF8pGa4ijz0XZ6IGF5u-gitbook-connector',
	ForgePioGithubDev: 'forge-connector-3QYYBgeNDilQB3Jc7uGMCchNgUGvCi7j-github-connector',
	ForgePioGithubProd: 'forge-connector-0Sw5Yr860fgfx5sYS7kEUoxnGhEvrhhI-github-connector',
	ForgePioGitlabDev: 'forge-connector-psr1wBkasRuKCwsvwi4aTJNhjmlVFebC-gitlab-connector',
	ForgePioGitlabProd: 'forge-connector-QLK5Xf8nBqejSZTulw5s3Cl6fIS24MwL-gitlab-connector',
	ForgePioGoogleDriveDev: 'forge-connector-JhqjCcAP6AHHxkYhY2akTgZsYXY93SMq-google-drive-connector',
	ForgePioGoogleDriveProd:
		'forge-connector-pcIwW04B398CSnilRIyzPJ5v5GevlCCo-google-drive-connector',
	ForgePioGuruDev: 'forge-connector-NtY3W5Z8JTBshAgPZFIfT7VjYAARj1P5-guru-connector',
	ForgePioGuruProd: 'forge-connector-mulxOVrXWOZObhFZH5WAqs7Ga2lCPK29-guru-connector',
	ForgePioHelpjuiceDev: 'forge-connector-f1rvRuAyoDWIwDs7Xubi5AZJTuESM5PC-helpjuice-connector',
	ForgePioHelpjuiceProd: 'forge-connector-8durapLyclxZeEexKkwxw6ZpCRpBz4dP-helpjuice-connector',
	ForgePioHubspotDev: 'forge-connector-RtvzhBL0FFFIjLCBHjXI8QfgDqAs79WF-hubspot-connector',
	ForgePioHubspotProd: 'forge-connector-O19vyTOCxgkZ6KSHycRjpzC0543x6Z0J-hubspot-connector',
	ForgePioSalesforceDev: 'forge-connector-50BYkfgS4GXtr6iO8qUeBFbbHHbuFleo-salesforce-connector',
	ForgePioSalesforceProd: 'forge-connector-nn5lJU1KJxJsUNML5GWV3blDYHMT6nAb-salesforce-connector',
	ForgePioSharepointDev: 'forge-connector-cl5i3J8L463hTuQiDt7f1mK4vZllsAo0-sharepoint-connector',
	ForgePioSharepointProd: 'forge-connector-7yrzYPlAOcZAif2tIymeDXBUNUAxI95G-sharepoint-connector',
	ForgePioStackOverflowDev:
		'forge-connector-ojk0u9oXGmVmS3BC7VmVSBPPIuuF5df3-stack-overflow-connector',
	ForgePioStackOverflowProd:
		'forge-connector-vUmPXguTcgLzdG1R3H0kTUQwxoGnZcsS-stack-overflow-connector',
	ForgeUtoolityGitbookDev: 'forge-connector-FEJ0dhTb8HC3UYmqhPAKYCWVTcpoHsp5-gitbook-connector',
	ForgeUtoolityGitbookProd: 'forge-connector-byNN1wfDuTnx7VndySG7Qq3ZfoXudUcL-gitbook-connector',
	ForgeGdriveEugeneTestDev: 'forge-connector-s7M8FnmJVPQh9FtRqvqwSL3QFtqMijua-gdrive',
	ForgeGdriveEugeneTestProd: 'forge-connector-bkRlqLiPfviKrVtbA6Q0QGN22x6b37mf-gdrive',
	// New 3P? Add it here
} as const;

export const ThirdPartyConfigs = new Map<ProductKeys3P, ThirdPartyConfig>([
	[ProductKeys3P.AtlassianWebCrawler, atlassianWebCrawlerConfig],
	[ProductKeys3P.Figma, figmaConfig],
	[ProductKeys3P.Github, githubConfig],
	[ProductKeys3P.GoogleDrive, googleDriveConfig],
	[ProductKeys3P.Sharepoint, sharepointConfig],
	[ProductKeys3P.Loom, loomConfig],
	[ProductKeys3P.OneDrive, oneDriveConfig],
	[ProductKeys3P.Dropbox, dropboxConfig],
	[ProductKeys3P.Slack, slackConfig],
	[ProductKeys3P.Teams, teamsConfig],
	[ProductKeys3P.GoogleCalendar, googleCalendarConfig],
	[ProductKeys3P.Gmail, gmailConfig],
	[ProductKeys3P.OutlookCalendar, outlookCalendarConfig],
	[ProductKeys3P.OutlookMail, outlookMail],
	[ProductKeys3P.Asana, asanaConfig],
	[ProductKeys3P.Zendesk, zendeskConfig],
	[ProductKeys3P.Airtable, airtableConfig],
	[ProductKeys3P.Smartsheet, smartsheetConfig],
	[ProductKeys3P.Notion, notionConfig],
	[ProductKeys3P.Miro, miroConfig],
	[ProductKeys3P.Docusign, docusignConfig],
	[ProductKeys3P.Lucid, lucidConfig],
	[ProductKeys3P.Monday, mondayConfig],
	[ProductKeys3P.AzureDevops, azureDevopsConfig],
	[ProductKeys3P.Gitlab, gitlabConfig],
	[ProductKeys3P.ConfluenceDC, confluenceDCConfig],
	[ProductKeys3P.Canva, canvaConfig],
	[ProductKeys3P.Box, boxConfig],
	[ProductKeys3P.Zeplin, zeplinConfig],
	[ProductKeys3P.ServiceNow, serviceNowConfig],
	[ProductKeys3P.Freshservice, freshserviceConfig],
	[ProductKeys3P.PowerBI, powerBIConfig],
	[ProductKeys3P.ClickUp, clickUpConfig],
	[ProductKeys3P.Amplitude, amplitudeConfig],
	[ProductKeys3P.Stripe, stripeConfig],
	[ProductKeys3P.AdobeXD, adobeXDConfig],
	[ProductKeys3P.Aha, ahaConfig],
	[ProductKeys3P.AdobeSign, adobeSignConfig],
	[ProductKeys3P.Mural, muralConfig],
	[ProductKeys3P.Webex, webexConfig],
	[ProductKeys3P.Todoist, todoistConfig],
	[ProductKeys3P.PagerDuty, pagerDutyConfig],
	[ProductKeys3P.Pipedrive, pipedriveConfig],
	[ProductKeys3P.Hubspot, hubSpotConfig],
	[ProductKeys3P.Dovetail, dovetailConfig],
	[ProductKeys3P.LaunchDarkly, launchDarklyConfig],
	[ProductKeys3P.Salesforce, salesforceConfig],
	[ProductKeys3P.Sentry, sentryConfig],
	[ProductKeys3P.JiraDC, jiraDCConfig],
	[ProductKeys3P.Gitbook, gitbookConfig],
	[ProductKeys3P.AWSS3, awss3Config],
	[ProductKeys3P.Databricks, databricksConfig],
	[ProductKeys3P.JsmDC, jsmDCConfig],
	[ProductKeys3P.ForgeAdamVitareqDev, forgeAdamVitareqDevConfig],
	[ProductKeys3P.ForgeAdamVitareqProd, forgeAdamVitareqProdConfig],
	[ProductKeys3P.ForgeK15tScrollSitesDev, forgeK15tScrollSitesDevConfig],
	[ProductKeys3P.ForgeK15tScrollSitesProd, forgeK15tScrollSitesProdConfig],
	[ProductKeys3P.ForgePioAwsDev, forgePioAwsDevConfig],
	[ProductKeys3P.ForgePioAwsProd, forgePioAwsProdConfig],
	[ProductKeys3P.ForgePioClickupDev, forgePioClickupDevConfig],
	[ProductKeys3P.ForgePioClickupProd, forgePioClickupProdConfig],
	[ProductKeys3P.ForgePioGitbookDev, forgePioGitbookDevConfig],
	[ProductKeys3P.ForgePioGitbookProd, forgePioGitbookProdConfig],
	[ProductKeys3P.ForgePioGithubDev, forgePioGithubDevConfig],
	[ProductKeys3P.ForgePioGithubProd, forgePioGithubProdConfig],
	[ProductKeys3P.ForgePioGitlabDev, forgePioGitlabDevConfig],
	[ProductKeys3P.ForgePioGitlabProd, forgePioGitlabProdConfig],
	[ProductKeys3P.ForgePioGoogleDriveDev, forgePioGoogleDriveDevConfig],
	[ProductKeys3P.ForgePioGoogleDriveProd, forgePioGoogleDriveProdConfig],
	[ProductKeys3P.ForgePioGuruDev, forgePioGuruDevConfig],
	[ProductKeys3P.ForgePioGuruProd, forgePioGuruProdConfig],
	[ProductKeys3P.ForgePioHelpjuiceDev, forgePioHelpjuiceDevConfig],
	[ProductKeys3P.ForgePioHelpjuiceProd, forgePioHelpjuiceProdConfig],
	[ProductKeys3P.ForgePioHubspotDev, forgePioHubspotDevConfig],
	[ProductKeys3P.ForgePioHubspotProd, forgePioHubspotProdConfig],
	[ProductKeys3P.ForgePioSalesforceDev, forgePioSalesforceDevConfig],
	[ProductKeys3P.ForgePioSalesforceProd, forgePioSalesforceProdConfig],
	[ProductKeys3P.ForgePioSharepointDev, forgePioSharepointDevConfig],
	[ProductKeys3P.ForgePioSharepointProd, forgePioSharepointProdConfig],
	[ProductKeys3P.ForgePioStackOverflowDev, forgePioStackOverflowDevConfig],
	[ProductKeys3P.ForgePioStackOverflowProd, forgePioStackOverflowProdConfig],
	[ProductKeys3P.ForgeUtoolityGitbookDev, forgeUtoolityGitbookDevConfig],
	[ProductKeys3P.ForgeUtoolityGitbookProd, forgeUtoolityGitbookProdConfig],
	[ProductKeys3P.ForgeGdriveEugeneTestDev, forgeGdriveEugeneTestDevConfig],
	[ProductKeys3P.ForgeGdriveEugeneTestProd, forgeGdriveEugeneTestProdConfig],
	// New 3P? Add it here
]);

export type ProductKeys3P = (typeof ProductKeys3P)[keyof typeof ProductKeys3P];

const ProductsOrder3P: ProductKeys3P[] = [
	// Loom is actually a 1P so goes to the top
	ProductKeys3P.Loom,

	// Eventually this might be "smart"
	// For now this static order isn't strongly defined
	ProductKeys3P.GoogleDrive,
	ProductKeys3P.Sharepoint,
	ProductKeys3P.OneDrive,
	ProductKeys3P.Dropbox,
	ProductKeys3P.Slack,
	ProductKeys3P.Teams,
	ProductKeys3P.Github,
	ProductKeys3P.Figma,
	ProductKeys3P.GoogleCalendar,
	ProductKeys3P.Gmail,
	ProductKeys3P.OutlookCalendar,
	ProductKeys3P.OutlookMail,
	ProductKeys3P.Airtable,
	ProductKeys3P.Smartsheet,
	ProductKeys3P.Asana,
	ProductKeys3P.Zendesk,
	ProductKeys3P.Miro,
	ProductKeys3P.Docusign,
	ProductKeys3P.Lucid,
	ProductKeys3P.Monday,
	ProductKeys3P.AzureDevops,
	ProductKeys3P.Gitlab,
	ProductKeys3P.ConfluenceDC,
	ProductKeys3P.Canva,
	ProductKeys3P.Box,
	ProductKeys3P.Zeplin,
	ProductKeys3P.ServiceNow,
	ProductKeys3P.Freshservice,
	ProductKeys3P.PowerBI,
	ProductKeys3P.ClickUp,
	ProductKeys3P.Amplitude,
	ProductKeys3P.Stripe,
	ProductKeys3P.AdobeXD,
	ProductKeys3P.Aha,
	ProductKeys3P.AdobeSign,
	ProductKeys3P.Mural,
	ProductKeys3P.Webex,
	ProductKeys3P.PagerDuty,
	ProductKeys3P.Pipedrive,
	ProductKeys3P.Dovetail,
	ProductKeys3P.LaunchDarkly,
	ProductKeys3P.Salesforce,
	ProductKeys3P.Sentry,
	ProductKeys3P.Gitbook,
	ProductKeys3P.AWSS3,
	ProductKeys3P.ForgeAdamVitareqDev,
	ProductKeys3P.ForgeAdamVitareqProd,
	ProductKeys3P.ForgeK15tScrollSitesDev,
	ProductKeys3P.ForgeK15tScrollSitesProd,
	ProductKeys3P.ForgePioAwsDev,
	ProductKeys3P.ForgePioAwsProd,
	ProductKeys3P.ForgePioClickupDev,
	ProductKeys3P.ForgePioClickupProd,
	ProductKeys3P.ForgePioGithubDev,
	ProductKeys3P.ForgePioGithubProd,
	ProductKeys3P.ForgePioGitbookDev,
	ProductKeys3P.ForgePioGitbookProd,
	ProductKeys3P.ForgePioGitlabDev,
	ProductKeys3P.ForgePioGitlabProd,
	ProductKeys3P.ForgePioGoogleDriveDev,
	ProductKeys3P.ForgePioGoogleDriveProd,
	ProductKeys3P.ForgePioGuruDev,
	ProductKeys3P.ForgePioGuruProd,
	ProductKeys3P.ForgePioHelpjuiceDev,
	ProductKeys3P.ForgePioHelpjuiceProd,
	ProductKeys3P.ForgePioHubspotDev,
	ProductKeys3P.ForgePioHubspotProd,
	ProductKeys3P.ForgePioSalesforceDev,
	ProductKeys3P.ForgePioSalesforceProd,
	ProductKeys3P.ForgePioSharepointDev,
	ProductKeys3P.ForgePioSharepointProd,
	ProductKeys3P.ForgePioStackOverflowDev,
	ProductKeys3P.ForgePioStackOverflowProd,
	ProductKeys3P.ForgeUtoolityGitbookDev,
	ProductKeys3P.ForgeUtoolityGitbookProd,
	ProductKeys3P.ForgeGdriveEugeneTestDev,
	ProductKeys3P.ForgeGdriveEugeneTestProd,
	// New 3P? Add it here
	ProductKeys3P.Databricks,
	ProductKeys3P.Notion,
	ProductKeys3P.Todoist,
	ProductKeys3P.Hubspot,
	ProductKeys3P.JiraDC,
	ProductKeys3P.JsmDC,

	// Always last
	ProductKeys3P.AtlassianWebCrawler,
];

// TODO: QS-8075 replace into PRODUCTS_ORDER when cleaning up the FG
const NewProductsOrder3P: ProductKeys3P[] = [
	// Loom is actually a 1P so goes to the top
	ProductKeys3P.Loom,

	// Eventually this might be "smart"
	// For now this static order isn't strongly defined
	ProductKeys3P.GoogleDrive,
	ProductKeys3P.Sharepoint,
	ProductKeys3P.Slack,
	ProductKeys3P.Teams,
	ProductKeys3P.Figma,
	ProductKeys3P.Miro,
	ProductKeys3P.Salesforce,
	ProductKeys3P.Github,
	ProductKeys3P.Gmail,
	ProductKeys3P.Gitlab,
	ProductKeys3P.Lucid,
	ProductKeys3P.Asana,
	ProductKeys3P.AzureDevops,
	ProductKeys3P.GoogleCalendar,
	ProductKeys3P.OneDrive,
	ProductKeys3P.Dropbox,
	ProductKeys3P.OutlookCalendar,
	ProductKeys3P.OutlookMail,
	ProductKeys3P.Airtable,
	ProductKeys3P.Smartsheet,
	ProductKeys3P.Zendesk,
	ProductKeys3P.Docusign,
	ProductKeys3P.Monday,
	ProductKeys3P.ConfluenceDC,
	ProductKeys3P.Canva,
	ProductKeys3P.Box,
	ProductKeys3P.Zeplin,
	ProductKeys3P.ServiceNow,
	ProductKeys3P.Freshservice,
	ProductKeys3P.PowerBI,
	ProductKeys3P.ClickUp,
	ProductKeys3P.Amplitude,
	ProductKeys3P.Stripe,
	ProductKeys3P.AdobeXD,
	ProductKeys3P.Aha,
	ProductKeys3P.AdobeSign,
	ProductKeys3P.Mural,
	ProductKeys3P.Webex,
	ProductKeys3P.PagerDuty,
	ProductKeys3P.Pipedrive,
	ProductKeys3P.Dovetail,
	ProductKeys3P.LaunchDarkly,
	ProductKeys3P.Sentry,
	ProductKeys3P.Gitbook,
	ProductKeys3P.AWSS3,
	ProductKeys3P.Notion,
	ProductKeys3P.Todoist,
	ProductKeys3P.Hubspot,
	ProductKeys3P.JiraDC,
	ProductKeys3P.JsmDC,

	// New 3P? Add it here
	ProductKeys3P.ForgeAdamVitareqDev,
	ProductKeys3P.ForgeAdamVitareqProd,
	ProductKeys3P.ForgeK15tScrollSitesDev,
	ProductKeys3P.ForgeK15tScrollSitesProd,
	ProductKeys3P.ForgePioAwsDev,
	ProductKeys3P.ForgePioAwsProd,
	ProductKeys3P.ForgePioClickupDev,
	ProductKeys3P.ForgePioClickupProd,
	ProductKeys3P.ForgePioGithubDev,
	ProductKeys3P.ForgePioGithubProd,
	ProductKeys3P.ForgePioGitbookDev,
	ProductKeys3P.ForgePioGitbookProd,
	ProductKeys3P.ForgePioGitlabDev,
	ProductKeys3P.ForgePioGitlabProd,
	ProductKeys3P.ForgePioGoogleDriveDev,
	ProductKeys3P.ForgePioGoogleDriveProd,
	ProductKeys3P.ForgePioGuruDev,
	ProductKeys3P.ForgePioGuruProd,
	ProductKeys3P.ForgePioHelpjuiceDev,
	ProductKeys3P.ForgePioHelpjuiceProd,
	ProductKeys3P.ForgePioHubspotDev,
	ProductKeys3P.ForgePioHubspotProd,
	ProductKeys3P.ForgePioSalesforceDev,
	ProductKeys3P.ForgePioSalesforceProd,
	ProductKeys3P.ForgePioSharepointDev,
	ProductKeys3P.ForgePioSharepointProd,
	ProductKeys3P.ForgePioStackOverflowDev,
	ProductKeys3P.ForgePioStackOverflowProd,
	ProductKeys3P.ForgeUtoolityGitbookDev,
	ProductKeys3P.ForgeUtoolityGitbookProd,
	ProductKeys3P.ForgeGdriveEugeneTestDev,
	ProductKeys3P.ForgeGdriveEugeneTestProd,
	// Always last
	ProductKeys3P.AtlassianWebCrawler,
];

/**
 * DO NOT import this directly
 *
 * Please use `import { ProductKeys3P } from 'src/common/constants/products.tsx'`
 */
export const DO_NOT_IMPORT_ProductKeys3P = ProductKeys3P;

/**
 * DO NOT import this directly
 *
 * Please use `import { ProductsOrder } from 'src/common/constants/products.tsx'`
 */
export const DO_NOT_IMPORT_ProductsOrder3P = ProductsOrder3P;
export const DO_NOT_IMPORT_NewProductsOrder3P = NewProductsOrder3P;
